import brookingsConfigure from "./widgets/configure.js";
import brookingsTaxonomyModalWidget from "./widgets/taxonomy-modal.js";
import brookingsExpertsModalWidget from "./widgets/experts-modal.js";
import brookingsEntitiesModalWidget from "./widgets/entities-modal.js";
import brookingsSearchBox from "./widgets/search-box.js";
import brookingsContentType from "./widgets/content-type.js";
import brookingsLocales from "./widgets/locale.js";
import brookingsDateMenu from "./widgets/date-filter.js";
import brookingsSortBy from "./widgets/sort-by.js";
import brookingsClearAll from "./widgets/clear-all.js";
import Event from "./templates/card-event.js";
import Card from "./templates/card.js";
import NoResults from "./templates/card-no-results.js";
import LoadMore from "./templates/loadmore.js";
import initOnScroll from "./helpers/initOnScroll.js";
import hideSnippet from "./helpers/snippet.js";
import defaults from "./helpers/defaults.js";
import checkRecaptcha from "./helpers/recaptcha.js";

document.addEventListener("DOMContentLoaded", function () {
	if ( !document.getElementById("filtered-feed") || algolia.indices.searchable_posts === undefined ) {
		return;
	}

	// instantiate instantsearch.js
	var search = instantsearch({
		indexName: algolia.indices.searchable_posts.name,
		searchClient: algoliasearch(
			algolia.application_id,
			algolia.search_api_key
		),
		onStateChange: (event) => {
			hideSnippet();
			event.setUiState(event.uiState);
		},
		routing: {
			router: instantsearch.routers.history({
				writeDelay: 1000,
			}),
			stateMapping: {
				stateToRoute(indexUi) {
					const searchQuery = brookingsAlgolia.is_search_page === 'true' ? 's' : 'qry';
					const indexUiState = indexUi[algolia.indices.searchable_posts.name];
					return {
						[searchQuery]: indexUiState.query,
						page: indexUiState.page,
						entities: indexUiState.refinementList && indexUiState.refinementList.entities,
						topics: indexUiState.refinementList && indexUiState.refinementList['taxonomies.topic_tax'],
						regions: indexUiState.refinementList && indexUiState.refinementList['taxonomies.region_tax'],
						experts: indexUiState.refinementList && indexUiState.refinementList['experts']
					};
				},
				routeToState(routeState) {
					const searchQuery = brookingsAlgolia.is_search_page === 'true' ? 's' : 'qry';
					const indexUiState = {};
					indexUiState[algolia.indices.searchable_posts.name] = {
						query: routeState[searchQuery],
						page: routeState.page,
						refinementList: {
							entities: routeState.entities,
							'taxonomies.topic_tax': routeState.topics,
							'taxonomies.region_tax': routeState.regions,
							'experts': routeState.experts,
						},
					};
					return indexUiState;
				},
			},
		},
	});

	const timeNow = Math.floor(Date.now() / 1000);

	let postFilters = JSON.parse(brookingsAlgoliaFeedOptions.filter);
	let perPage = JSON.parse(brookingsAlgoliaFeedOptions.per_page);

	// add search widgets
	search.addWidgets([

		brookingsConfigure({
			searchParameters: {
				hitsPerPage: Number(perPage),
				filters: postFilters,
				distinct: true,
				// clickAnalytics: true,
			},
		}),

		// clear all
		brookingsClearAll({
			container: document.querySelector('#cs-clear-refinements'),
		}),

		// sortby
		// brookingsSortBy({
		// 	container: document.querySelector('#sort-by'),
		// 	items: [
		// 		{ label: 'Newest', value: algolia.indices.searchable_posts.name },
		// 		{ label: 'Oldest', value: 'ascending_date' },
		// 	],
		// }),

		// search box widget
		brookingsSearchBox({
			container: "#cs-search-box",
			placeholder: "Search for...",
			showReset: false,
			showSubmit: false,
			showLoadingIndicator: false,
		}),

		// stats widget
		instantsearch.widgets.stats({
			container: "#algolia-stats",
			templates: {
				text(data, { html }) {
				  let count = '';
			
				  if (data.hasManyResults) {
					count += `${data.nbHits} results`;
				  } else if (data.hasOneResult) {
					count += `1 result`;
				  } else {
					count += `No results`;
				  }
			
				  return html`<span>${count} found</span>`;
				},
			},
		}),

		// date menu widget
		brookingsContentType({
			attribute: "content_type",
			operator: "and",
			limit: 100,
		}),

		brookingsLocales({
			attribute: "locale",
			operator: "or",
			limit: 20,
		}),
		
		// date menu widget
		brookingsDateMenu({
			container: document.querySelector('#facet-dates'),
			attribute: 'post_date',
			items: [
				{ label: 'Past 30 days', end: timeNow, start: Math.floor(Date.now() / 1000) - 2592000 },
				{ label: 'Past 6 Months', end: timeNow, start: Math.floor(Date.now() / 1000) - 15552000 },
				{ label: 'Last Year',  end: timeNow, start: Math.floor(Date.now() / 1000) - 31536000 },
			],
		}),

		// topics modal widget 
		brookingsTaxonomyModalWidget({
			attribute: "tax_ids.topic_tax",
			operator: "and",
			limit: 100,
			taxonomy: 'topic'
		}),

		// regions modal widget 
		brookingsTaxonomyModalWidget({
			attribute: "tax_ids.region_tax",
			operator: "and",
			limit: 100,
			taxonomy: 'region'
		}),

		// experts modal widget 
		brookingsExpertsModalWidget({
			attribute: "expert_ids",
			operator: "and",
			limit: 30000,
			taxonomy: 'person'
		}),

		// entities modal widget 
		brookingsEntitiesModalWidget({
			attribute: "entity_ids",
			operator: "and",
			limit: 100,
		}),

		// hits widget
		instantsearch.widgets.infiniteHits({
			container: "#algolia-hits",
			hitsPerPage: Number(perPage),
			cssClasses: {
				list: ["articles-stream flex flex-col gap-5"],
			},
			templates: {
				empty(results, { html }) {
					return NoResults(results);
				},
				showMoreText() {
					return LoadMore();
				},
				item(hit, { html, components, sendEvent }) {
					switch ( hit.post_type ) {
						case 'event':
							return Event(hit, { html, components, sendEvent }, );
						default:
							return Card(hit, { html, components, sendEvent }, defaults);
					}
				},
			},
			transformData: {
				item: function (hit) {
					function replace_highlights_recursive(item) {
						if (
							item instanceof Object &&
							item.hasOwnProperty("value")
						) {
							item.value = _.escape(item.value);
							item.value = item.value
								.replace(/__ais-highlight__/g, "<em>")
								.replace(/__\/ais-highlight__/g, "</em>");
						} else {
							for (var key in item) {
								item[key] = replace_highlights_recursive(
									item[key]
								);
							}
						}
						return item;
					}

					hit._highlightResult = replace_highlights_recursive(
						hit._highlightResult
					);
					hit._snippetResult = replace_highlights_recursive(
						hit._snippetResult
					);

					return hit;
				},
			},
		}),
	]);

	// checkRecaptcha(initOnScroll, search); // uncomment to enable recaptcha
	initOnScroll(search);
});
